import { motion } from 'framer-motion'
import {
  Phone,
  Mail,
  MapPin,
  Award,
  ArrowRight,
  Shield,
  Star,
  Users,
  ChevronUp,
} from 'lucide-react'
import { Button } from '../ui/button'
import { useNavigate } from 'react-router'
import logo from '../../assets/logo_white.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faLinkedin, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons'
// The main Footer1 component with a new, updated design.
export function Footer2() {
  const navigate = useNavigate()
  const quickLinks = [
    { label: 'Home', href: 'home' },
    { label: 'About Us', href: 'about' },
    { label: 'Services', href: 'services' },
    { label: 'Portfolio', href: 'portfolio' },
    { label: 'Pricing', href: 'pricing' },
    { label: 'Contact', href: 'contact' },
  ]

  const services = [
    { label: 'Lawn Maintenance', href: 'services' },
    { label: 'Garden Design', href: 'services' },
    { label: 'Tree Services', href: 'services' },
    { label: 'Hardscaping', href: 'services' },
    { label: 'Irrigation Systems', href: 'services' },
    { label: 'Seasonal Cleanup', href: 'services' },
  ]

  const socialLinks = [
    { icon: <FontAwesomeIcon icon={faFacebook} size="lg" color="#000000" />, href: '#', label: 'Facebook' },
    { icon: <FontAwesomeIcon icon={faInstagram} size="lg" color="#000000" />, href: '#', label: 'Instagram' },
    { icon: <FontAwesomeIcon icon={faXTwitter} size="lg" color="#000000" />, href: '#', label: 'Twitter' },
    { icon: <FontAwesomeIcon icon={faLinkedin} size="lg" color="#000000" />, href: '#', label: 'LinkedIn' },
    { icon: <FontAwesomeIcon icon={faYoutube} size="lg" color="#000000" />, href: '#', label: 'YouTube' },
  ]

  const certifications = [
    { icon: <Shield className="w-5 h-5" />, text: 'Licensed & Insured' },
    { icon: <Award className="w-5 h-5" />, text: 'ISA Certified Arborist' },
    { icon: <Star className="w-5 h-5" />, text: 'BBB A+ Rating' },
    { icon: <Users className="w-5 h-5" />, text: '500+ Happy Clients' },
  ]

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const scrollToSection = (href) => {
    // setPage(href)
    // window.scrollTo(0, 0)
    navigate(href.replace('#', '/').replace('home', ''))
    window.scrollTo(0, 0)
  }

  return (
    <footer className="bg-[#551D00] text-white relative overflow-hidden font-sans">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-auto" viewBox="0 0 100 100" fill="none">
          <defs>
            <pattern
              id="footer-pattern-light"
              width="4"
              height="4"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M-1 1l2-2M0 4l4-4M3 5l2-2"
                stroke="currentColor"
                strokeOpacity="0.2"
                strokeWidth="1"
              />
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#footer-pattern-light)" />
        </svg>
      </div>

      <div className="relative z-10">
        {/* Newsletter Section */}
        <motion.div
          className="bg-white py-16 shadow-lg"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h3 className="text-3xl font-bold mb-4 text-white">
                Stay Ahead with Our Green Insights
              </h3>
              <p className="text-gray-500 mb-8 max-w-2xl mx-auto">
                Subscribe to our newsletter for expert landscaping tips,
                exclusive offers, and seasonal advice delivered straight to your
                inbox.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-lg mx-auto mb-6">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="flex-1 px-6 py-3 rounded-lg text-gray-800 border-2 border-gray-300 focus:ring-2 focus:ring-green-500 focus:outline-none"
                />
                <Button className="bg-green-600 h-[48px] hover:bg-green-500 text-white font-semibold px-8 py-3 whitespace-nowrap shadow-lg">
                  Subscribe
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </div>
              <p className="text-gray-400 text-sm">
                Join over 2,000+ happy homeowners. Unsubscribe at any time.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Main Footer Content */}
        <div className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
              {/* Column 1: Company Info */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="flex items-center space-x-3 mb-6">
                  <img src={logo} alt="logo-w" className="h-12" />

                </div>
                <p className="text-white mb-6 leading-relaxed">
                  Crafting beautiful, sustainable outdoor spaces for over 15
                  years. We transform ordinary into extraordinary.
                </p>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <Phone className="w-5 h-5 mr-3 text-green-600" />
                    <a
                      href="tel:+15551234567"
                      className="text-white hover:text-green-600 transition-colors"
                    >
                      (555) 123-4567
                    </a>
                  </div>
                  <div className="flex items-center">
                    <Mail className="w-5 h-5 mr-3 text-green-600" />
                    <a
                      href="mailto:demo@example.com"
                      className="text-white hover:text-green-600 transition-colors"
                    >
                      demo@example.com
                    </a>
                  </div>
                  <div className="flex items-start">
                    <MapPin className="w-5 h-5 mr-3 text-green-600 mt-1 flex-shrink-0" />
                    <span className="text-white">
                      123 Garden Lane
                      <br />
                      Green Valley, CA 90210
                    </span>
                  </div>
                </div>
              </motion.div>

              {/* Column 2: Quick Links */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                <h4 className="text-lg font-semibold mb-6 text-white">
                  Quick Links
                </h4>
                <ul className="space-y-3">
                  {quickLinks.map((link, index) => (
                    <li key={index}>
                      <button
                        onClick={() => scrollToSection(link.href)}
                        className="text-white hover:text-green-600 transition-colors flex items-center group"
                      >
                        <ArrowRight className="w-4 h-4 mr-2 text-green-500 opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all duration-300" />
                        {link.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </motion.div>

              {/* Column 3: Our Services */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <h4 className="text-lg font-semibold mb-6 text-white">
                  Our Services
                </h4>
                <ul className="space-y-3">
                  {services.map((service, index) => (
                    <li key={index}>
                      <button
                        onClick={() => scrollToSection(service.href)}
                        className="text-white hover:text-green-600 transition-colors flex items-center group"
                      >
                        <ArrowRight className="w-4 h-4 mr-2 text-green-500 opacity-0 group-hover:opacity-100 transform -translate-x-2 group-hover:translate-x-0 transition-all duration-300" />
                        {service.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </motion.div>

              {/* Column 4: Certifications & Social */}
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <h4 className="text-lg font-semibold mb-6 text-white">
                  Certifications & Awards
                </h4>
                <div className="space-y-3 mb-8">
                  {certifications.map((cert, index) => (
                    <div key={index} className="flex items-center">
                      <span className="text-green-600 mr-3">{cert.icon}</span>
                      <span className="text-white text-sm">{cert.text}</span>
                    </div>
                  ))}
                </div>
                <h4 className="text-lg font-semibold mb-4 text-white">
                  Follow Us
                </h4>
                <div className="flex space-x-3">
                  {socialLinks.map((social, index) => (
                    <motion.a
                      key={index}
                      href={social.href}
                      className="w-10 h-10 bg-gray-200 hover:bg-gray-200 text-gray-500 hover:text-white rounded-full flex items-center justify-center transition-colors duration-300"
                      whileHover={{ scale: 1.1, y: -2 }}
                      whileTap={{ scale: 0.95 }}
                      aria-label={social.label}
                    >
                      {social.icon}
                    </motion.a>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#3d0404] py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-6 text-sm text-white">
                <span>Copyright © 2025, Gardenly. All Rights Reserved.</span>
                <div className="flex space-x-6">
                  <a
                    href="#"
                    className="hover:text-green-600 transition-colors"
                  >
                    Privacy Policy
                  </a>
                  <a
                    href="#"
                    className="hover:text-green-600 transition-colors"
                  >
                    Terms of Service
                  </a>
                  <a
                    href="#"
                    className="hover:text-green-600 transition-colors"
                  >
                    Sitemap
                  </a>
                </div>
              </div>
              <Button
                size="sm"
                onClick={scrollToTop}
                className="bg-green-600 text-white hover:bg-green-600 border border-green-600 shadow-md"
              >
                Back to Top
                <ChevronUp className="ml-2 w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
